import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=e6f86b2a&scoped=true&"
import script from "./SettingsCard.vue?vue&type=script&lang=ts&"
export * from "./SettingsCard.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCard.vue?vue&type=style&index=0&id=e6f86b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f86b2a",
  null
  
)

export default component.exports